<template>
  <button type="button" class="edit-btn l-btn" @click="openEditChatPopup">
    <IconModify class="icon" />
    <span>{{ t('label_edit_interpretation') }}</span>
  </button>
  <button type="button" class="edit-btn l-btn" @click="openQrPopup">
    <img :src="getAssetImageUrl('common/icons/qr-icon.svg')" alt="qr" />
    <span>{{ t('invite_qr_code') }}</span>
  </button>
  <!-- TODO: 기록 다운로드 구현 후 진행 예정
  <button type="button" class="edit-btn l-btn" @click="openDownloadPopup">
    <IconDownload class="icon" />
    <span>{{ t('download') }}</span>
  </button> -->
  <button type="button" class="edit-btn l-btn" @click="openDeletePopup">
    <IconTrash class="icon" />
    <span>{{ t('button_delete') }}</span>
  </button>
</template>

<script setup lang="ts" generic="T = unknown">
import { h } from 'vue';

import { deleteCall } from '@/api/apiService';
import Modal from '@/components/domains/mobile/common/PopupModal.vue';
import PopupDownload from '@/components/domains/mobile/popup/PopupDownload.vue';
import PopupQrcode from '@/components/domains/mobile/popup/PopupQrcode.vue';
import IconModify from '@/components/jh-app/icons/IconModify.vue';
import IconTrash from '@/components/jh-app/icons/IconTrash.vue';
import { useChatStore } from '@/stores/chat';
import { usePopupStore } from '@/stores/popup';
import { ChatItem } from '@/types/components';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const props = withDefaults(
  defineProps<{
    payload: ChatItem;
    refresh: () => void;
  }>(),
  {}
);
const emit = defineEmits(['close']);

const { t } = useI18n();
const router = useRouter();

const { setChatInfo } = useChatStore();
const popupStore = usePopupStore();

const openEditChatPopup = () => {
  emit('close');

  setChatInfo(props.payload);
  router.push(`/app/chat/${props.payload.code}`);
};

const openQrPopup = () => {
  emit('close');
  popupStore.open(Modal, {
    title: t('use_sconchat_on_phone'),
    subTitle: t('description_use_qr'),
    contentSlot: h(PopupQrcode),
    showHandleBar: true,
    payload: props.payload,
  });
};

const openDownloadPopup = () => {
  emit('close');
  popupStore.open(Modal, {
    title: t('download_call_history'),
    subTitle: t('history_retention_notice'),
    contentSlot: h(PopupDownload),
    confirmButton: { text: t('button_confirm') },
    payload: props.payload,
  });
};

const openDeletePopup = () => {
  emit('close');
  popupStore.open(Modal, {
    title: t('question_delete'),
    subTitle: t('description_delete_chat'),
    iconSlot: h('img', {
      src: getAssetImageUrl('app/status/delect.svg'),
      alt: 'delete_icon',
    }),
    cancelButton: { text: t('button_cancel') },
    confirmButton: { text: t('delete_voice'), action: () => deleteChat() },
    payload: props.payload,
  });
};

const deleteChat = async () => {
  try {
    const { success } = await deleteCall(props.payload.code);

    const message = success ? 'alert_delete_success' : 'retry_after_few_minutes';
    popupStore.openToast(t(message));

    props.refresh?.();
  } catch (error) {
    console.error('통역방 삭제 실패: ', error);
  }
};
</script>

<style scoped lang="scss">
.edit-btn {
  display: flex;
  justify-content: flex-start;
  transition: all 0.2s;
  img,
  svg {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  span {
    font-size: $font-size-psmall;
  }
  &:hover {
    background: $gray10;
    transform: scale(0.97);
  }
}
</style>
